
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/videos",
      function () {
        return require("private-next-pages/android/local/videos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/videos"])
      });
    }
  